import React, { useState, useEffect } from 'react';

export default function ScrollUpButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      onClick={scrollUp}
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '1rem',
        zIndex: 999,
        width: 48,
        height: 48,
        background: 'var(--blue)',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 20px rgba(26,79,156,0.4)',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.3s ease',
        pointerEvents: visible ? 'auto' : 'none',
      }}
      aria-label="Scroll to top"
      onMouseEnter={e => e.currentTarget.style.background = '#153d7a'}
      onMouseLeave={e => e.currentTarget.style.background = 'var(--blue)'}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
        <path d="M18 15l-6-6-6 6"/>
      </svg>
    </button>
  );
}
